import { render, staticRenderFns } from "./forms-management.vue?vue&type=template&id=28ee48a1&scoped=true"
import script from "./forms-management.vue?vue&type=script&lang=ts"
export * from "./forms-management.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee48a1",
  null
  
)

export default component.exports